import { mobileLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  @media screen and (${mobileLargeMax}) {
    span {
      font-size: 20px;
    }
  }
`;

export default Container;
